import { IconsProps } from '@/types/shared'

const VideoIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.25 16.3C1.61667 15.5667 1.10833 14.75 0.725 13.85C0.341667 12.95 0.1 12 0 11H2.05C2.15 11.7333 2.33333 12.4292 2.6 13.0875C2.86667 13.7458 3.21667 14.35 3.65 14.9L2.25 16.3ZM0 8.99999C0.133333 7.99999 0.383333 7.04999 0.75 6.14999C1.11667 5.24999 1.61667 4.43332 2.25 3.69999L3.65 5.09999C3.21667 5.64999 2.86667 6.25415 2.6 6.91249C2.33333 7.57082 2.15 8.26665 2.05 8.99999H0ZM8.95 19.95C7.95 19.85 7.00417 19.6083 6.1125 19.225C5.22083 18.8417 4.4 18.35 3.65 17.75L5.05 16.3C5.63333 16.7333 6.24583 17.0917 6.8875 17.375C7.52917 17.6583 8.21667 17.85 8.95 17.95V19.95ZM5.1 3.69999L3.65 2.24999C4.4 1.64999 5.22083 1.15832 6.1125 0.774988C7.00417 0.391654 7.96667 0.149988 9 0.0499878V2.04999C8.25 2.14999 7.55 2.34165 6.9 2.62499C6.25 2.90832 5.65 3.26665 5.1 3.69999ZM7.5 14.5V5.49999L14.5 9.99999L7.5 14.5ZM11 19.95V17.95C13.0167 17.6667 14.6875 16.775 16.0125 15.275C17.3375 13.775 18 12.0167 18 9.99999C18 7.98332 17.3375 6.22499 16.0125 4.72499C14.6875 3.22499 13.0167 2.33332 11 2.04999V0.0499878C13.5667 0.333321 15.7083 1.41665 17.425 3.29999C19.1417 5.18332 20 7.41665 20 9.99999C20 12.5833 19.1417 14.8167 17.425 16.7C15.7083 18.5833 13.5667 19.6667 11 19.95Z"
                    fill="#EA4336"
                />
            </svg>
        </div>
    )
}

export default VideoIcons
